document.addEventListener('DOMContentLoaded', function() {
  const reviewSection = document.getElementById('shopify-section-template--19482102333517__176915340099b17f8b');
  if (reviewSection) {
    reviewSection.id = 'reviews'; // 替换或保留原ID
    // 或者在其内部插入锚点
    const anchor = document.createElement('div');
    anchor.id = 'reviews';
    reviewSection.prepend(anchor);
  }
});
